import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import ImageTextCard from "@components/WebsiteRevamp/ImageTextCard/ImageTextCard"
import {Size} from "@components/WebsiteRevamp/Typography/Typography"
import {
	AdvancedSideAssetMainContent,
	AdvancedSideAssetModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"

import TitleSection from "../TitleSection/TitleSection"

import styles from "./LogosListSection.module.scss"

type Props = {
	pageData: AdvancedSideAssetModuleType
}

const LogosListSection = (props: Props) => {
	return (
		<section>
			<ContainerWrapper>
				<Separator size={128}>
					<TitleSection pageData={props.pageData} />
					<Separator />
					<div className={styles.container}>
						{props.pageData.mainContent?.map(
							(
								element: AdvancedSideAssetMainContent,
								index: number,
							) => {
								return (
									<ImageTextCard
										key={index}
										buttonContainerProps={{
											className: `${styles.buttonContainerClass}`,
										}}
										className={styles.card}
										imageProps={{
											containerClassName:
												styles.imageContainerClassName,
											imageClassName:
												styles.imageContainerClass,
										}}
										contentContainer={
											styles.contentContainer
										}
										contentProps={{
											data: element,
											titleProps: {
												size: Size.M,
												style: {
													marginBottom: "2rem",
												},
											},
										}}
									/>
								)
							},
						)}
					</div>
				</Separator>
			</ContainerWrapper>
		</section>
	)
}

export default LogosListSection
